// extracted by mini-css-extract-plugin
export default {"UploadImageTips":"upload-image-tips_UploadImageTips__EpMqZ","tips":"upload-image-tips_tips__RNU8R"};